import { render } from "./submenu-icon.vue?vue&type=template&id=c3bac1da&scoped=true"
import script from "./submenu-icon.vue?vue&type=script&lang=js"
export * from "./submenu-icon.vue?vue&type=script&lang=js"

import "./submenu-icon.vue?vue&type=style&index=0&id=c3bac1da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3bac1da"]])

export default __exports__